import { types, flow } from 'mobx-state-tree';
import { login, logout, whoami } from '../api/auth';
import { api, handleResponse } from '../api';
import { getStore } from './index';
import { User, parseUser } from './UserStore';

const LoginStore = types
  .model('LoginData', {
    currentUser: types.optional(User, {}),
    isLoggedIn: types.optional(types.boolean, false),
    status: types.optional(
      types.enumeration('status', ['idle', 'pending', 'done', 'error']),
      'idle',
    ),
  })
  .actions(self => {
    const setUser = user => {
      self.currentUser = parseUser(user);
    };
    const verifyCookie = flow(function*() {
      self.status = 'pending';
      const response = yield whoami();
      handleResponse([
        [
          200,
          () => {
            self.isLoggedIn = true;
            self.status = 'done';
            setUser(response.data);
          },
        ],
        [
          'default',
          () => {
            self.isLoggedIn = false;
            self.squuid = '';
            self.status = 'error';
          },
        ],
      ])(response);
      return response;
    });
    const loginAsync = flow(function*(email, password) {
      self.status = 'pending';
      getStore('appStore').setIsLoading(true);
      const response = yield login({ email, password });
      handleResponse([
        [
          200,
          () => {
            self.isLoggedIn = true;
            self.status = 'done';
            getStore('appStore').setIsLoading(false);
            setUser(response.data);
            getStore('notificationStore').clear();
            getStore('notificationStore').raiseInfo(
              'notifications.login.success',
              {
                name: self.currentUser.name,
              },
            );
          },
        ],
        [
          401,
          () => {
            self.isLoggedIn = false;
            self.squuid = '';
            self.status = 'error';
            getStore('appStore').setIsLoading(false);
            getStore('notificationStore').raiseError(
              'notifications.login.failed',
            );
          },
        ],
        [
          'default',
          () => {
            self.isLoggedIn = false;
            self.squuid = '';
            self.status = 'error';
            getStore('appStore').setIsLoading(false);
            getStore('notificationStore').raiseError(
              'notifications.login.error',
            );
          },
        ],
      ])(response);
      return response;
    });
    const logoutAsync = flow(function*() {
      self.status = 'pending';
      getStore('appStore').setIsLoading(true);
      const response = yield logout();
      handleResponse([
        [
          200,
          () => {
            self.isLoggedIn = false;
            self.status = 'done';
            self.currentUser = {};
            getStore('appStore').setIsLoading(false);
            getStore('notificationStore').raiseInfo(
              'notifications.logout.success',
            );
          },
        ],
        [
          'default',
          () => {
            self.status = 'error';
            getStore('appStore').setIsLoading(false);
            getStore('notificationStore').raiseError(
              'notifications.logout.error',
            );
          },
        ],
      ])(response);
      return response;
    });
    return {
      loginAsync,
      logoutAsync,
      verifyCookie,
    };
  })
  .views(self => ({
    get isValid() {
      return self.isLoggedIn;
    },
  }));

export { LoginStore };
